import { PalavraPastor, Publicacao, ParoquiaAcao } from "../index"

export const HomeAdmin = () => {
    return(
        <>
            <Publicacao />
            <PalavraPastor/>
            <ParoquiaAcao />
        </>
    )
}